module.exports = __webpack_public_path__ + "static/media/bass-logo-new@3x.e2fbc00b.png";